import React from 'react';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = 'h-6 w-auto' }) => (
  <>
    <img
      src="/wellsite-logo-color.svg"
      alt="Wellsite"
      className={`${className} block dark:hidden`}
    />
    <img
      src="/wellsite-logo-white.svg"
      alt="Wellsite"
      className={`${className} hidden dark:block`}
    />
  </>
);

export default Logo;
